package com.karawek.core.network

import com.karawek.core.auth.api.AuthSessionManager
import io.ktor.client.plugins.api.createClientPlugin
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.util.AttributeKey

class AuthPluginConfig {
    lateinit var authSessionManager: AuthSessionManager
}

val AuthModeAttributeKey = AttributeKey<AuthMode>("AuthMode")

val AuthClientPlugin = createClientPlugin("AuthClientPlugin", ::AuthPluginConfig) {
    val authSessionManager = pluginConfig.authSessionManager

    onRequest { request, _ ->
        val mode = request.attributes.getOrNull(AuthModeAttributeKey) ?: AuthMode.Jwt
        val credentialType = mode.credentialType()
        val credential = credentialType?.let {
            authSessionManager.getCredential(it)
        }

        if (credentialType != null && credential == null) {
            // No live credential — the session is gone. Clear local state so the
            // auth gate resets the app to login, then abort this request.
            authSessionManager.invalidateLocal()
            throw SessionExpiredException()
        }

        if (credential != null) {
            request.headers.append(
                HttpHeaders.Authorization,
                "Bearer $credential",
            )
        }
    }

    onResponse { response ->
        if (response.status == HttpStatusCode.Companion.Unauthorized) {
            authSessionManager.invalidateLocal()
        }
    }
}